import Core                   from '@/core/Core';
import DriverFeedback         from '@/domains/Drivers/DriverFeedback';
import DriverFeedbacksDAO     from '@/domains/Drivers/DriverFeedbacksDAO';

import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';

/**
 * Сервис для работы с оценками водителей
 */
class DriverFeedbacksService {

  // ============================================================
  // Чтение
  // ============================================================

  /**
   * Загрузить список оценок с пагинацией (например, все отзывы о водителе)
   */
  static async getListPaginated(
    params?: Parameters<typeof DriverFeedbacksDAO.getList>[0] & {
      pagination?: RpcDataPagination;
      sort?: RpcDataSort;
    }
  ): Promise<{ data: DriverFeedback[]; pagination: RpcDataPagination | null }> {
    const { pagination, sort, ...filters } = params ?? {};
    const response = await DriverFeedbacksDAO.getList(filters, pagination, sort);

    return {
      data:       Core.utils.hydrateArray(response.data, DriverFeedback.fromServer),
      pagination: response.meta?.pagination ?? null,
    };
  }

  /**
   * Загрузить список оценок без пагинации
   */
  static async getList(params?: Parameters<typeof DriverFeedbacksDAO.getList>[0]): Promise<DriverFeedback[]> {
    return (await this.getListPaginated(params)).data;
  }

  // ============================================================
  // Запись
  // ============================================================

  /**
   * Поставить или изменить свою оценку водителю.
   * Бэк возвращает false, если изменений не было — это не ошибка
   */
  static async upsert(driverFeedback: DriverFeedback): Promise<boolean> {
    const response = await DriverFeedbacksDAO.upsert(driverFeedback);

    if (response.ok) {
      Core.showNotification.success('Оценка сохранена');
    }

    return response.ok;
  }
}

export default DriverFeedbacksService;
